import { HStack, Switch } from "@chakra-ui/react";

import {
  LinearTrackingEntityDisplay,
  LinearTrackingEntityDisplayProps,
} from "./LinearTrackingEntityDisplay";

type LinearTrackingEntityToggleProps = Omit<
  LinearTrackingEntityDisplayProps,
  "search"
> & {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
};

export function LinearTrackingEntityToggle({
  enabled,
  entity,
  showIcon = true,
  showTypeIcon = true,
  onToggle,
  ...stackProps
}: LinearTrackingEntityToggleProps) {
  return (
    <HStack width="full" {...stackProps}>
      <Switch
        isChecked={enabled}
        size="sm"
        onChange={(value) => {
          onToggle(value.target.checked);
        }}
      />
      <LinearTrackingEntityDisplay
        entity={entity}
        showIcon={showIcon}
        showTypeIcon={showTypeIcon}
      />
    </HStack>
  );
}
